import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export interface BankTransferInfo {
  account_holder: string;
  iban: string;
  bic: string;
  bank_name: string;
}

// Bankverbindung für Überweisungen (aus den Rechnungs-Einstellungen,
// über eine SECURITY-DEFINER-Funktion auch für Schüler lesbar).
// Liefert null, solange nicht geladen oder keine IBAN hinterlegt ist.
export function useBankTransferInfo(enabled: boolean): BankTransferInfo | null {
  const [info, setInfo] = useState<BankTransferInfo | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    supabase.rpc('get_bank_transfer_info').then(({ data, error }) => {
      if (cancelled || error) return;
      const row = (Array.isArray(data) ? data[0] : data) as BankTransferInfo | undefined;
      if (row && (row.iban ?? '').trim()) setInfo(row);
    });
    return () => { cancelled = true; };
  }, [enabled]);

  return info;
}
